/* Footer-Link "Als App installieren" - NICHT fixiert, im Footer-Fluss, verdeckt nie Kauf-Knoepfe. Ersetzt das notabgeschaltete Overlay-Banner. Kein Emoji (Premium/Kundenflaeche). */
(function () {
  try {
    var standalone = (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;
    if (standalone) return;
    function build() {
      if (document.getElementById("ys-appinstall-link")) return;
      var host = document.querySelector(".footer__content-bottom") || document.querySelector(".footer") || document.querySelector("footer");
      if (!host) return;
      var wrap = document.createElement("div");
      wrap.id = "ys-appinstall-link";
      wrap.style.cssText = "text-align:center;padding:12px 12px 4px;font-family:inherit;";
      var btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = "Als App installieren";
      btn.style.cssText = "background:none;border:1px solid currentColor;opacity:.7;color:inherit;border-radius:10px;padding:8px 16px;font-size:13px;letter-spacing:.02em;cursor:pointer;font-family:inherit;";
      var hint = document.createElement("div");
      hint.style.cssText = "display:none;margin:8px auto 0;max-width:520px;font-size:12.5px;opacity:.8;line-height:1.5;";
      var isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
      var deferred = null;
      window.addEventListener("beforeinstallprompt", function (e) { e.preventDefault(); deferred = e; });
      btn.addEventListener("click", function () {
        if (deferred) { deferred.prompt(); deferred.userChoice.then(function () { deferred = null; }); return; }
        hint.innerHTML = isIOS
          ? "iPhone (Safari): unten auf das <b>Teilen-Symbol</b> tippen und <b>&bdquo;Zum Home-Bildschirm&ldquo;</b> w&auml;hlen."
          : "Browser-Men&uuml; (drei Punkte) &rarr; <b>&bdquo;App installieren&ldquo;</b> bzw. &bdquo;Zum Startbildschirm hinzuf&uuml;gen&ldquo; &ndash; oder das Installieren-Symbol in der Adressleiste.";
        hint.style.display = "block";
      });
      wrap.appendChild(btn); wrap.appendChild(hint);
      host.appendChild(wrap);
    }
    if (document.readyState !== "loading") build(); else document.addEventListener("DOMContentLoaded", build);
  } catch (e) {}
})();
